<template>
  <dd-header-card header="Selectie overzicht">
    <template #action>
      <dd-button :small="true">
        <template #icon>{{ total }}</template>
      </dd-button>
    </template>
    <template v-if="loading">
      Laden ...
    </template>
    <dd-main-table
        v-else-if="hasSearchables"
        @load-page="onLoadPage"
        :initial-load-page-object="loadPageObject"
        :rounded="true"
        :rows="searchables"
        :loading="loading"
        :headers="previewHeaders"
        :paginator="pagination"
        :has-select="false"
    />
    <template v-else>
      Geen resultaten
    </template>
  </dd-header-card>

</template>

<script>
import searchModelInterfaceApi from '~/api/search_model_interface';
import debounce from 'lodash/debounce';
import HTMLCell from "~/new_design_components/tables/cell_types/HTMLCell.vue";
import CustomerAvatarCell from '~/new_design_components/tables/cell_types/CustomerAvatarCell.vue'

export default {
  name: 'SelectionPreviewComponent.vue',
  props: {
    search: {
      type: Object,
      required: false,
      default: null
    },
    searchId: {
      type: [String, Number],
      required: true,
    },
    dynamicExtendingSearchIds: {
      type: Array,
      required: false,
    },
  },
  watch: {
    searchId () {
      this.clearResults()
      this.debounceGetSelectionPreview()
    },
    dynamicExtendingSearchIds () {
      this.clearResults()
      this.debounceGetSelectionPreview()
    }
  },
  created () {
    this.debounceGetSelectionPreview()
  },
  computed: {
    hasSearchables () {
      return this.searchables && this.searchables.length > 0
    },
    total () {
      return this.pagination?.total
    },
    previewHeaders () {
      let headers = []

      if (this.search.model === 'App\\Models\\Customer') {
        headers.push({
          title: 'Naam',
          typeComponent: CustomerAvatarCell,
          key: (row) => row.customer?.data,
        })
      } else {
        headers.push({
          title: 'Naam',
          typeComponent: HTMLCell,
          key: (row) => row.name
        })
      }

      if (this.search && this.search.model !== 'App\\Models\\Customer') {
        headers.push({
          title: 'Klant',
          typeComponent: CustomerAvatarCell,
          key: (row) => row.customer?.data
        })
      }

      headers.push({
        title: 'Type',
        width: '150px',
        key: (row) => row.description,
      })

      return headers
    }
  },
  data () {
    return {
      searchables: [],
      pagination: null,
      loading: true,
      loadPageObject: {
        perPage: 15,
        page: 1,
      },
    }
  },
  methods: {
    clearResults () {
      this.searchables = []
      this.pagination = null
      this.loading = true
    },
    onLoadPage (pageObject) {
      this.loadPageObject = pageObject
      this.debounceGetSelectionPreview()
    },
    debounceGetSelectionPreview: debounce(function () {
      this.getSelectionPreview()
    }, 500),
    getSelectionPreview () {
      if (!this.searchId) return

      this.loading = true

      searchModelInterfaceApi.selectionPreview(
        this.searchId,
        this.dynamicExtendingSearchIds,
        this.loadPageObject.page,
        this.loadPageObject.perPage,
      ).then((response) => {
        this.searchables = response.data
        this.pagination = response.meta?.pagination
        this.loading = false
      })

      this.loading = true
    },
  }
}
</script>

<style scoped>

</style>
